import React from "react";
import { TaskRow } from "../zype/styled-components";
import { Button, Card, Checkbox, Modal, Tooltip, Typography } from "antd";
import { ArrowRightOutlined, UploadOutlined } from "@ant-design/icons";
import { StyledDragger, uploaderContent } from "../import/videos";
import { UploadProps } from "antd/lib";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import Dragger from "antd/es/upload/Dragger";

type AnalyticsUploadModalProps = {
	handleUpload: () => void;
	uploadProps: UploadProps;
	removeDuplicates: boolean;
	setRemoveDuplicates: (value: CheckboxChangeEvent) => void;
	isUploadModalOpen: boolean;
	handleUploadModalClose: () => void;
	isUploading: boolean;
};

const AnalyticsUploadModal: React.FC<AnalyticsUploadModalProps> = ({
	handleUpload,
	uploadProps,
	removeDuplicates,
	setRemoveDuplicates,
	isUploadModalOpen,
	handleUploadModalClose,
	isUploading,
}) => {
	return (
		<Modal
			title="Import Analytics Data"
			open={isUploadModalOpen}
			onCancel={handleUploadModalClose}
			footer={null}
		>
			{/* <TaskRow> */}
			<Card
				actions={[
					<Button key="import-btn" type="primary" onClick={handleUpload} loading={isUploading}>
						{isUploading ? "Uploading..." : "Import Analytics Data"}
					</Button>,
				]}
			>
				<Tooltip
					placement="top"
					overlayStyle={{ maxWidth: "500px" }}
					title={
						<>
							Required Columns:
							<ul>
								<li>
									<ArrowRightOutlined /> Date - values should be in YYYY-MM-DD, YYYY/MM/DD,
									MM/DD/YYYY, MM-DD-YYYY format
								</li>
								<li>
									<ArrowRightOutlined /> HOV or Hours of viewership. Don&apos;t include both the
									columns
								</li>
								<li>
									<ArrowRightOutlined /> Platform
								</li>
								<li>
									<ArrowRightOutlined /> Channel
								</li>
								<li>
									<ArrowRightOutlined /> Territory
								</li>
							</ul>
						</>
					}
				>
					<Dragger {...uploadProps} style={{ marginBottom: 16 }}>
						<Typography.Paragraph>Please select a CSV file to import analytics data</Typography.Paragraph>
						<Button icon={<UploadOutlined />} loading={isUploading}>Select a File</Button>
					</Dragger>
				</Tooltip>

				<Checkbox checked={removeDuplicates} onChange={setRemoveDuplicates}>
					Remove Duplicates
				</Checkbox>
			</Card>
			{/* </TaskRow> */}
		</Modal>
	);
};

export default AnalyticsUploadModal;
